import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var EditorCopy = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.668 0H14.226c-.3 0-.501.1-.702.3L4.201 9.623c-.2.2-.301.4-.301.701V34.58a2.01 2.01 0 0 0 2.005 2.004h1.404c.601 0 1.002-.501 1.002-1.002 0-.602-.501-1.002-1.002-1.002H6.005V11.326h7.419c1.003 0 1.905-.802 1.905-1.804V2.005h15.339v1.703c0 1.404 2.005 1.404 2.005 0V2.005A2.01 2.01 0 0 0 30.668 0ZM13.224 9.321H7.409l5.814-5.813v5.813ZM34.477 36.182H17.133c-1.303 0-1.303-2.004 0-2.004h17.344c1.304 0 1.304 2.004 0 2.004Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.477 26.861H17.133a1.005 1.005 0 0 1-1.002-1.002c0-.602.501-1.003 1.002-1.003h17.344c1.304-.1 1.304 1.905 0 2.005ZM34.477 17.44h-8.622c-1.303 0-1.303-2.005 0-2.005h8.622c1.304 0 1.304 2.005 0 2.005Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.287 7.517H22.046c-.502 0-.902.2-1.303.501l-8.823 8.82c-.3.301-.601.602-.501 1.002-.2.401.1 23.955 0 24.356 0 1.002.802 1.804 1.804 1.804h25.064a1.797 1.797 0 0 0 1.804-1.804V9.32c.1-1.002-.701-1.804-1.804-1.804Zm-17.544 3.508v5.813h-5.815l5.814-5.813Zm17.343 31.07H13.424V18.844h7.519a1.797 1.797 0 0 0 1.805-1.804V9.522h15.338v32.574Z"
  }));
});
EditorCopy.displayName = 'EditorCopy';
EditorCopy.defaultProps = {
  'aria-label': 'EditorCopy'
};
export default EditorCopy;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/EditorCopy.js
// module id = 2919
// module chunks = 11